import { Flex, Image } from '@podiumhq/design-system';
import PropTypes from 'prop-types';

const CustomerText = ({ image, content, width = '259px' }) => (
  <Flex w="100%" justifyContent="flex-end">
    <Flex borderRadius="6px" alignItems="flex-end" mr="8px">
      <Image w="43px" src={image} alt="customer profile picture" />
    </Flex>
    <Flex
      w={width}
      p="16px"
      borderRadius="24px"
      bg="silver.lightest"
      borderBottomLeftRadius="0px"
      flexDir="column"
    >
      {content}
    </Flex>
  </Flex>
);

CustomerText.propTypes = {
  image: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  width: PropTypes.string,
};

export default CustomerText;
